export default {
    list: {
        title: "Demandes de retrait",
        name: 'balancesHistories',
        class: "min-h-screen flex-1 mt-1 bg-gray-100 px-3 items-center",
        sousTable: false,
        options: {
            defaultPageSize: 5,
            actions: {
                isActive: false,
                method: false,
                link: false,
                name: "Actions",
                buttons: [],
            }
        },
        columns: [
            {
                name: "id",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        name: "id",
                        type: "text",
                    }],
                }, ]
            },
            {
                name: "seller",
                class: "text-left",
                elements: [{
                    items: [{
                        class: "ouka",
                        name: "seller",
                        elements: [{
                            items: [{
                                    name: "fullName",
                                    class: "font-bold text-gray-700",
                                    icone: "contacts"
                                },
                                {
                                    name: "email",
                                    class: "font-light text-gray-700",
                                    icone: "email"
                                },
                                {
                                    name: "type",
                                    class: "font-light text-gray-500 text-xs",
                                    icone: "person"
                                }
                            ]
                        }]

                    }, ],
                }, ]
            },
            {
                name: "Montant",
                class: "font-bold",
                elements: [{
                    items: [{
                        class: "font-bold text-gray-700",
                        name: "displayAmount",
                        type: "text",
                    }],
                }, ]
            },
            {
                name: "Méthode de paiement",
                class: "",
                elements: [{
                    items: [{
                        class: "text-xs text-gray-600",
                        name: "displayPaymentMethod",
                        type: "text",
                    }],
                }, ]
            },
            {
                name: "operationType",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        name: "operationType",
                        type: "text",
                    }],
                }, ]
            },
            {
                name: "status",
                class: "",
                elements: [{
                    items: [{
                        class: "select-status",
                        options: ['pending', 'paid', 'rejected'],
                        name: "status",
                        selects: true,
                        table: "balancesHistories",
                        type: "text",
                    }],
                }, ]
            },
            {
                name: "defaultCurrency",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        name: "defaultCurrency",
                        type: "text",
                    }],
                }, ]
            },
            {
                name: "comment",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        name: "comment",
                        type: "text",
                    }],
                }, ]
            },
            {
                name: "createdAt",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        date: true,
                        name: "createdAt",
                        type: "text",
                    }],
                }, ]
            },
        ],
        actions: {
            name: "actions",
            width: "10px",
            class: "justify-end",
            elements: [],
        },
        filters: {
            name: 'balancesHistories',
            elements: {
                search: {
                    options: {
                        icon: "search",
                        label: "search",
                        class: "",
                        hint: "search by id",
                    },
                    value: null,
                    type: "search",
                    validate: {
                        trim: true,
                        required: false,
                        minlength: 0,
                    }
                },
                champs: [{
                        label: "status",
                        key: "status",
                        value: null,
                        values: ['pending', 'paid', 'rejected'],
                        class: 'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
                        type: "select",
                    },
                    {
                        label: "currency",
                        key: "defaultCurrency",
                        value: null,
                        values: ['MAD', 'USD'],
                        class: 'py-2 text-xs uppercase px-2 outline-none block h-full w-full bg-white',
                        type: "select",
                    },
                    {
                        label: "seller",
                        key: "seller",
                        name: "fullName",
                        value: null,
                        values: [],
                        class: 'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
                        type: "select",
                    },
                    {
                        label: "date",
                        key: "date",
                        value: null,
                        placeholder: "Date",
                        type: "date",
                        class: "py-2 text-xs px-2 outline-none block h-full w-full"
                    },
                ],
            },
        },
    },
}
